<template>
    <div v-if="tables.length > 0" class="orphan-section">
        <div class="orphan-header">
            <div>
                <h3 class="orphan-title">Tables non liées</h3>
                <p class="orphan-description mb-0">Ces tables sont rattachées au restaurant mais pas encore à une salle d'un plan de salle.</p>
            </div>
        </div>

        <div class="table-responsive">
            <table class="table table-sm orphan-table mb-0">
                <thead>
                    <tr>
                        <th>Table</th>
                        <th>Couverts</th>
                        <th>QR code</th>
                        <th>Associer à une salle</th>
                        <th class="text-end">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="table in tables" :key="`orphan-${table.id}`">
                        <td class="fw-bold">{{ table.name }}</td>
                        <td>{{ table.seats }}</td>
                        <td>
                            <span :class="['small', table.url ? 'text-success' : 'text-muted']">
                                {{ table.url ? "Généré" : "À générer" }}
                            </span>
                        </td>
                        <td>
                            <select
                                :value="roomAssignments[table.id] || ''"
                                class="form-select form-select-sm select-native mb-0"
                                :disabled="!hasSelectableRooms"
                                @change="updateRoomAssignment(table.id, $event.target.value)">
                                <option value="">{{ hasSelectableRooms ? "Choisir une salle" : "Aucune salle disponible" }}</option>
                                <optgroup v-for="plan in seatingPlansWithRooms" :key="`plan-${plan.id}`" :label="plan.name">
                                    <option v-for="room in plan.rooms" :key="`room-${room.id}`" :value="String(room.id)">
                                        {{ room.name }}
                                    </option>
                                </optgroup>
                            </select>
                        </td>
                        <td class="text-end">
                            <button
                                type="button"
                                class="btn btn-outline-success btn-sm me-2"
                                :disabled="associationLoadingIds.includes(table.id) || !(roomAssignments[table.id] || '')"
                                @click="$emit('associate', table)">
                                Associer
                            </button>
                            <button
                                type="button"
                                class="btn btn-outline-danger btn-sm"
                                :disabled="deletionLoadingIds.includes(table.id)"
                                @click="$emit('delete', table)">
                                Supprimer
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: "OrderingTableUnlinkedTables",
    props: {
        tables: {
            type: Array,
            required: true,
        },
        seatingPlans: {
            type: Array,
            required: true,
        },
        roomAssignments: {
            type: Object,
            required: true,
        },
        associationLoadingIds: {
            type: Array,
            required: true,
        },
        deletionLoadingIds: {
            type: Array,
            required: true,
        },
    },
    computed: {
        seatingPlansWithRooms() {
            return this.seatingPlans.filter((plan) => plan.rooms.length > 0);
        },
        hasSelectableRooms() {
            return this.seatingPlansWithRooms.length > 0;
        },
    },
    methods: {
        updateRoomAssignment(tableId, roomId) {
            this.$emit("update-room-assignment", { tableId, roomId });
        },
    },
};
</script>

<style scoped lang="scss">
.orphan-section {
    margin-top: 10px;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.orphan-header {
    padding: 18px 18px 10px 18px;
    border-bottom: 1px solid #f3f4f6;
}

.orphan-title {
    margin: 0 0 6px 0;
    font-size: 16px;
    font-weight: 700;
    color: #111827;
}

.orphan-description {
    font-size: 13px;
    color: #6b7280;
}

.orphan-table {
    thead th {
        border-top: none;
        background: #f9fafb;
        color: #4b5563;
        font-size: 12px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.03em;
    }

    td,
    th {
        padding: 12px 18px;
        vertical-align: middle;
    }
}
</style>
